import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectLocationSurveyData,
    selectLocationSurveyStatus,
    selectLocationSurveyError,
    initializeAsync,
} from "./locationSurveySlice";
import { Typography, Button, Box, Grid, Container, Divider, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
//import { useMediaQuery } from "react-responsive";
import { useParams, useNavigate } from "react-router-dom";
import { get, post } from "../../api";
import Paper from "@mui/material/Paper";
import { CustomGrid } from "../../components/Grid/CustomGrid";
import { ModalContent } from "../../components/ModalContent";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PlainTextField from "../../components/InputField/PlainTextField";
import OutlinedTextField from "../../components/InputField/OutlinedTextField";
import { CardContainer } from "../../components/CardContainer";
import { IconButton } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import AutoComplete from "../../components/InputField/AutoComplete";
import { AlertDialog } from "../../components/AlertDialog";
import { ImageUpload } from "../../components/ImageUpload";
import LockIcon from "@mui/icons-material/Lock";
import { useMediaQuery } from "@mui/material";
const classes = {
    paper: {
        height: "100%",
        textAlign: "center",
        padding: "10px 12px",
        margin: "2px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
};

const paperClasses = {
    paper: {
        width: "100%",
        borderRadius: 5,
    },
};

const labels = {
    location: { body: "Location#", size: 1 },
    name: { body: "Friendly Name", size: 3 },
    section: { body: "Section" },
    height: { body: " Wall Height(in)" },
    width: { body: "Wall Width(in)" },
    image: { body: "Wall Photo" },
};

const LocationSurvey = () => {
    const data = useSelector(selectLocationSurveyData);
    const status = useSelector(selectLocationSurveyStatus);
    const error = useSelector(selectLocationSurveyError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    //const isDesktop = useMediaQuery({ minWidth: 1250 });
    const isDesktop = useMediaQuery("(min-width:1250px)");
    const [isNewRow, setIsNewRow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [addingLocation, setAddingLocation] = useState(false);

    let { accountId, recordId } = useParams();
    const uploadDocumentRef = useRef();
    const navigate = useNavigate();

    const [orderDetails, setOrderDetails] = useState();
    const [loadingOrder, setLoadingOrder] = useState(true);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
    const [deleteValue, setDeleteValue] = useState();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formValues, setFormValues] = useState([]);

    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    useEffect(() => {
        if (recordId) {
            get("opportunity/getRecordById", {
                recordId: recordId,
            }).then(async (result) => {
                if (result.isSuccess) {
                    setOrderDetails(result.data[0]);
                }
                setLoadingOrder(false);
            });
            get("artLocationSurvey/getRecordById", {
                recordId: recordId,
            }).then(async (result) => {
                if (result.isSuccess) {
                    //console.log("GET RECORD :: ", result.data);
                    if (result.data?.length > 0) {
                        setFormValues(result.data);
                        let options = [];
                        for (let row of result.data) {
                            if (row.section && options.indexOf(row.section) === -1) {
                                options.push(row.section);
                            }
                        }
                        setOptions(options);
                    } else {
                        handleAddRowClick();
                    }
                    setLoadingData(false);
                } else {
                    setLoadingData(false);
                }
            });
        }
    }, []);

    const handleChange = (id, value, index) => {
        let newFormValues = [...formValues];
        newFormValues[index][id] = value;
        setFormValues(newFormValues);
        // console.log("OnChange :: ", newFormValues);
    };
    const handleDeleteClick = (index, id) => {
        setOpenDeleteConfirmModal(true);
        setDeleteValue({ index, id });
    };

    const handleDeleteDisagree = () => {
        setOpenDeleteConfirmModal(false);
        setDeleteValue();
    };

    const handleDeleteAgree = () => {
        if (deleteValue) {
            if (deleteValue.id) {
                post("artLocationSurvey/deleteRecordById", {
                    recordId: deleteValue.id,
                }).then(async (result) => {
                    if (result.isSuccess) {
                        let newFormValues = [...formValues];
                        newFormValues.splice(deleteValue.index, 1);
                        newFormValues = newFormValues.map((item, index) => {
                            return { ...item, locationNumber: index + 1 };
                        });
                        setFormValues(newFormValues);
                        setLoadingData(false);
                        handleDeleteDisagree();
                        post("artLocationSurvey/updateArtLocation", newFormValues).then(async (result) => {
                            if (result.isSuccess) {
                                // console.log("BEFORE NEW FORM :: ", newFormValues);
                                // newFormValues[index] = result.data;
                                // console.log("AFTER NEW FORM :: ", newFormValues);
                            }
                        });
                    } else {
                        setLoadingData(false);
                    }
                });
            }
        }
    };

    const handleFileUploadComplete = (file, documentType) => {
        alert("Complete");
    };

    const handleBlur = (value, index) => {
        let newFormValues = [...formValues];
        if (newFormValues?.length > 0 && newFormValues[index]) {
            if (newFormValues[index]?.section && !options.includes(newFormValues[index]?.section)) {
                setOptions([...options, newFormValues[index]?.section]);
            }
            post("artLocationSurvey/createArtLocation", newFormValues[index]).then(async (result) => {
                if (result.isSuccess) {
                    // console.log("BEFORE NEW FORM :: ", newFormValues);
                    // newFormValues[index] = result.data;
                    // console.log("AFTER NEW FORM :: ", newFormValues);
                }
            });
        }
    };

    const getForm = (index) => {
        console.log("get Form :: ", index);
        if (loadingData) {
            console.log("Still loading");
        } else {
            const form = {
                location: {
                    body: (
                        <Grid container direction="column">
                            <Grid item>
                                <Box
                                    sx={{
                                        textAlign: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        height: "72px",
                                        marginTop: orderDetails?.status === "In-Progress" ? "-7px" : "-24px",
                                        borderBottom: "1px solid #d6d6d6",
                                    }}>
                                    <Typography sx={{ fontSize: "1rem", fontWeight: 500, lineHeight: 1.5 }}>
                                        {formValues[index]?.locationNumber}
                                    </Typography>
                                </Box>
                            </Grid>

                            {orderDetails?.status === "In-Progress" ? (
                                <Grid item>
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            height: "72px",
                                        }}>
                                        <Button
                                            variant="text"
                                            color="error"
                                            onClick={(e) => handleDeleteClick(index, formValues[index]?.id)}>
                                            Delete
                                        </Button>
                                    </Box>
                                </Grid>
                            ) : (
                                <Box
                                    sx={{
                                        height: "50px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}>
                                    <LockIcon sx={{ marginTop: "15px", color: "gray" }}></LockIcon>
                                </Box>
                            )}
                        </Grid>
                    ),

                    size: 1,
                },
                name: {
                    body: (
                        <Box sx={{ p: "1rem" }}>
                            <PlainTextField
                                autoFocus
                                id="name"
                                readOnly={orderDetails?.status !== "In-Progress"}
                                label=""
                                placeholder="Enter friendly name"
                                name="name"
                                fullWidth
                                multiline={false}
                                minRows={3}
                                maxRows={5}
                                value={formValues[index]?.name !== "[Blank]" ? formValues[index]?.name : ""}
                                onChange={(value) => handleChange("name", value, index)}
                                onBlur={(value) => handleBlur(value, index)}
                            />
                        </Box>
                    ),
                    size: 3,
                },
                section: {
                    body: (
                        <Box sx={{ px: "1rem", mt: 0.5 }}>
                            <AutoComplete
                                id="section"
                                label=""
                                readOnly={orderDetails?.status !== "In-Progress"}
                                placeholder="Assign a section"
                                name="section"
                                fullWidth
                                multiline={false}
                                minRows={3}
                                maxRows={5}
                                options={options}
                                value={formValues[index]?.section}
                                onChange={(value) => handleChange("section", value, index)}
                                onBlur={(value) => handleBlur(value, index)}
                            />
                        </Box>
                    ),
                },
                height: {
                    body: (
                        <Box sx={{ p: "1rem" }}>
                            <PlainTextField
                                id="height"
                                type="number"
                                label=""
                                readOnly={orderDetails?.status !== "In-Progress"}
                                placeholder="H''"
                                name="height"
                                fullWidth
                                min={0}
                                multiline={false}
                                minRows={3}
                                maxRows={5}
                                value={formValues[index]?.height == 0 ? "" : formValues[index]?.height}
                                onChange={(value) => handleChange("height", value, index)}
                                onBlur={(value) => handleBlur(value, index)}
                            />
                        </Box>
                    ),
                },
                width: {
                    body: (
                        <Box sx={{ p: "1rem" }}>
                            <PlainTextField
                                id="width"
                                type="number"
                                label=""
                                readOnly={orderDetails?.status !== "In-Progress"}
                                placeholder="W''"
                                name="width"
                                fullWidth
                                multiline={false}
                                minRows={3}
                                min={0}
                                maxRows={5}
                                value={formValues[index]?.width == 0 ? "" : formValues[index]?.width}
                                onChange={(value) => handleChange("width", value, index)}
                                onBlur={(value) => handleBlur(value, index)}
                            />
                        </Box>
                    ),
                },
                image: {
                    body: (
                        <Box sx={{ p: "1rem" }}>
                            <ImageUpload
                                disableUpload={orderDetails?.status !== "In-Progress"}
                                ref={uploadDocumentRef}
                                parentId={formValues[index]?.id}
                                id={"surveyLocation" + formValues[index]?.id}
                                userDetails={{}}
                                onFileUploadComplete={(file, documentType) =>
                                    handleFileUploadComplete(index, file, documentType)
                                }
                                documentType="surveyLocation"></ImageUpload>
                        </Box>
                    ),
                },
            };

            return form;
        }
    };

    const getFormInMobileView = (index) => {
        if (loadingData) {
            console.log("Still loading");
        } else {
            return (
                <Box sx={{ px: 0, mx: 0, position: "relative", height: "100%" }}>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontSize: "1.2rem",
                            fontWeight: 700,
                            lineHeight: 1.5,
                        }}>
                        {index + 1}
                    </Typography>
                    <Box
                        sx={{
                            px: "1rem",
                            m: 0,
                            borderTop: "1px solid #d6d6d6",
                        }}>
                        <OutlinedTextField
                            autoFocus
                            id="name"
                            label="Location"
                            alignCenter={true}
                            readOnly={orderDetails?.status !== "In-Progress"}
                            placeholder="Enter friendly name"
                            name="name"
                            margin="normal"
                            isRequired={true}
                            fullWidth
                            multiline={false}
                            minRows={3}
                            maxRows={5}
                            value={formValues[index]?.name !== "[Blank]" ? formValues[index]?.name : ""}
                            onChange={(value) => handleChange("name", value, index)}
                            onBlur={(value) => handleBlur(value, index)}
                        />
                    </Box>

                    <Box sx={{ px: "1rem" }}>
                        <AutoComplete
                            autoFocus
                            id="section"
                            headingLabel="Section *"
                            label="Section"
                            displayLabel={true}
                            placeholder="Assign a section"
                            readOnly={orderDetails?.status !== "In-Progress"}
                            name="section"
                            margin="normal"
                            alignCenter={true}
                            isRequired={true}
                            fullWidth
                            multiline={false}
                            minRows={3}
                            maxRows={5}
                            options={options}
                            value={formValues[index]?.section}
                            onChange={(value) => handleChange("section", value, index)}
                            onBlur={(value) => handleBlur(value, index)}
                        />
                    </Box>
                    <Grid container spacing={2} sx={{ px: "1rem" }}>
                        <Grid item xs={6}>
                            <OutlinedTextField
                                autoFocus
                                id="height"
                                label="Wall Height"
                                type="number"
                                readOnly={orderDetails?.status !== "In-Progress"}
                                placeholder="H"
                                name="height"
                                margin="normal"
                                alignCenter={true}
                                isRequired={true}
                                fullWidth
                                multiline={false}
                                minRows={3}
                                maxRows={5}
                                value={formValues[index]?.height == 0 ? "" : formValues[index]?.height}
                                onChange={(value) => handleChange("height", value, index)}
                                onBlur={(value) => handleBlur(value, index)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <OutlinedTextField
                                autoFocus
                                id="width"
                                type="number"
                                readOnly={orderDetails?.status !== "In-Progress"}
                                label="Wall Width"
                                placeholder="W"
                                name="width"
                                margin="normal"
                                alignCenter={true}
                                isRequired={true}
                                multiline={false}
                                minRows={3}
                                maxRows={5}
                                value={formValues[index]?.width == 0 ? "" : formValues[index]?.width}
                                onChange={(value) => handleChange("width", value, index)}
                                onBlur={(value) => handleBlur(value, index)}
                            />
                        </Grid>
                    </Grid>

                    <Box
                        sx={{
                            p: "1rem",
                            width: "100%",
                            textAlign: "center",
                            borderTop: "1px solid #d6d6d6",
                            borderBottom: "1px solid #d6d6d6",
                        }}>
                        <ImageUpload
                            disableUpload={orderDetails?.status !== "In-Progress"}
                            ref={uploadDocumentRef}
                            parentId={formValues[index]?.id}
                            id={"surveyLocation" + formValues[index]?.id}
                            userDetails={{}}
                            onFileUploadComplete={(file, documentType) =>
                                handleFileUploadComplete(index, file, documentType)
                            }
                            documentType="surveyLocation"></ImageUpload>
                    </Box>
                </Box>
            );
        }
    };

    const getSubmittedArtLocation = (index) => {
        if (formValues) {
            return (
                <Box
                    sx={{
                        px: 0,
                        minWidth: "300px",
                    }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-start", px: 2 }}>
                        <Typography variant="body1" component="div" color={"text.secondary"} sx={{ mr: 2 }}>
                            <strong>{index + 1}</strong>
                        </Typography>

                        <Typography variant="body1" component="div">
                            <strong>{formValues[index]?.name}</strong>
                        </Typography>
                    </Box>

                    <Divider></Divider>
                    <Box sx={{ px: 2, mt: 2 }}>
                        <Typography variant="body1" component="div" color={"text.secondary"}>
                            Section:{" "}
                            <Typography sx={{ display: "inline" }} color={"text.primary"}>
                                <strong>{formValues[index]?.section}</strong>
                            </Typography>
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "flex-start", px: 2, mb: 2 }}>
                        <Typography variant="body1" component="div" sx={{ mr: 4 }} color={"text.secondary"}>
                            W:{" "}
                            <Typography sx={{ display: "inline" }} color={"text.primary"}>
                                <strong>{formValues[index]?.width + '"'}</strong>
                            </Typography>
                        </Typography>
                        <Typography variant="body1" component="div" sx={{ mr: 2 }} color={"text.secondary"}>
                            H:{" "}
                            <Typography sx={{ display: "inline" }} color={"text.primary"}>
                                <strong>{formValues[index]?.height + '"'}</strong>
                            </Typography>
                        </Typography>
                    </Box>
                    <Divider></Divider>
                    <Box
                        sx={{
                            p: "1rem",
                            width: "100%",
                            textAlign: "center",
                        }}>
                        <ImageUpload
                            disableUpload={orderDetails?.status !== "In-Progress"}
                            ref={uploadDocumentRef}
                            parentId={formValues[index]?.id}
                            id={"surveyLocation" + formValues[index]?.id}
                            userDetails={{}}
                            onFileUploadComplete={(file, documentType) =>
                                handleFileUploadComplete(index, file, documentType)
                            }
                            documentType="surveyLocation"></ImageUpload>
                    </Box>
                    <Divider></Divider>
                </Box>
            );
        }
    };

    // Add Variables

    const handleAddRowClick = () => {
        setAddingLocation(true);
        post("artLocationSurvey/createArtLocation", {
            id: "",
            accountId: userDetails?.contact?.accountId,
            opportunityId: recordId,
            name: "[Blank]",
            section: "",
            height: "",
            width: "",
            featureOnWebsite: "",
            publishedAssetLink: "",
            locationNumber: formValues?.length + 1,
        }).then(async (result) => {
            if (result.isSuccess) {
                setFormValues([...formValues, result.data]);
            }
            setAddingLocation(false);
        });
    };

    const handleOpenModal = (value) => {
        setOpenImageModal(value);
    };

    const handleDisagree = () => {
        setOpenConfirmModal(false);
    };

    const handleAgree = () => {
        let record = { ...orderDetails };
        setIsSubmitting(true);
        record.status = "Survey Submitted";
        post("opportunity/createOrder", record).then((result) => {
            if (result.isSuccess) {
                setOrderDetails(result.data);
            } else {
                setIsSubmitting(false);
            }
        });
        setOpenConfirmModal(false);
    };

    const handleSubmitSurveyClick = (event) => {
        setOpenConfirmModal(true);
    };

    const handleBrowseGallery = () => {
        navigate("/favourite", { replace: false });
    };

    const handleGoToDashboard = () => {
        navigate("/", { replace: false });
    };

    let body = (
        <Container maxWidth>
            <Grid xs={12} container spacing={2} sx={{ mb: 2 }}>
                <Grid item xl={6} lg={6} md={12} xs={12} sx={{ textAlign: isDesktop ? "left" : "center" }}>
                    <Typography variant="h3"> Art Location Survey</Typography>
                    <Typography variant="subtitle1" color="text.disabled">
                        <strong>{orderDetails?.name}</strong>
                    </Typography>
                </Grid>
                <Grid
                    item
                    xl={6}
                    lg={6}
                    md={12}
                    xs={12}
                    sx={{
                        textAlign: isDesktop ? "right" : "center",
                        width: "100%",
                        display: "flex",
                        direction: "row",
                        justifyContent: isDesktop ? "flex-end" : "center",
                    }}>
                    {orderDetails?.status === "Survey Submitted" ? (
                        <Box
                            sx={{
                                border: 1,
                                borderRadius: 1,
                                display: "flex",
                                justifyContent: "center",
                                p: 1,
                                width: "max-content",
                                alignItems: "center",
                            }}>
                            <Typography variant="body1">Your survey is currently under review !</Typography>{" "}
                            <Button
                                variant="text"
                                size="small"
                                sx={{ p: 0, ml: 1, width: "fit-content" }}
                                onClick={handleOpenModal}>
                                What's next?
                            </Button>
                        </Box>
                    ) : (
                        <LoadingButton
                            loading={isSubmitting}
                            variant="contained"
                            onClick={(e) => handleSubmitSurveyClick(e)}
                            id="locationSurvey"
                            color="success"
                            size="large">
                            Submit survey for review
                        </LoadingButton>
                    )}
                </Grid>
            </Grid>

            <Box sx={{ width: "100%", borderBottom: 1, m: 0, borderColor: "grey.500" }}>
                {isDesktop ? (
                    <CustomGrid
                        border={false}
                        borderleft={false}
                        borderRight={false}
                        text={"secondary"}
                        disablePadding={true}
                        records={labels}
                        textAlign={"center"}
                    />
                ) : (
                    <></>
                )}
            </Box>

            {!loadingData &&
                formValues?.map((record, index) => {
                    return isDesktop ? (
                        <Paper style={paperClasses.paper} key={record.id}>
                            <CustomGrid
                                text={"primary"}
                                border={false}
                                borderleft={false}
                                borderRight={true}
                                disablePadding={false}
                                records={getForm(index)}
                            />
                        </Paper>
                    ) : (
                        <CardContainer
                            px={0}
                            m={0}
                            key={record.id}
                            actions={
                                <Box sx={{ mt: 8, mb: 2, width: "100%" }}>
                                    <Box
                                        sx={{
                                            py: 10,
                                            mb: 2,
                                            justifyContent: "center",
                                        }}>
                                        {orderDetails?.status === "In-Progress" ? (
                                            <Grid item xs={12}>
                                                <Box style={classes.paper}>
                                                    <Button
                                                        variant="text"
                                                        color="error"
                                                        onClick={(e) =>
                                                            handleDeleteClick(index, formValues[index]?.id)
                                                        }>
                                                        Delete
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        ) : (
                                            <Box
                                                sx={{
                                                    height: "50px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}>
                                                <LockIcon sx={{ marginTop: "15px", color: "gray" }}></LockIcon>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            }
                            contentOnCenter={true}>
                            {orderDetails?.status === "Survey Submitted"
                                ? getSubmittedArtLocation(index)
                                : getFormInMobileView(index)}
                        </CardContainer>
                    );
                })}
            {orderDetails?.status !== "Survey Submitted" && (
                <Box
                    sx={{
                        width: "100%",
                        textAlign: isDesktop ? "right" : "center",
                        display: "flex-end",
                        justifyContent: "center",
                    }}>
                    <LoadingButton
                        sx={{ mr: 1 }}
                        disabled={isSubmitted}
                        loading={addingLocation}
                        variant="contained"
                        size="large"
                        onClick={(e) => handleAddRowClick(e)}
                        id="addSurvey"
                        color="primary"
                        endIcon={<AddIcon color="white" />}>
                        Add new location
                    </LoadingButton>
                </Box>
            )}

            {openImageModal && (
                <ModalContent openModal={handleOpenModal} open={openImageModal} isSurvey={true}>
                    <Box sx={{ maxWidth: "22rem", m: "0px auto" }}>
                        <Typography variant="subtitle1" color="white" sx={{ wordSpacing: "1px", lineHeight: "18px" }}>
                            Great Work!
                        </Typography>
                        <Typography variant="subtitle1" color="white" sx={{ wordSpacing: "1px", lineHeight: "18px" }}>
                            We will review your survey and will be in contact with you soon regarding the next steps.
                        </Typography>

                        <Typography
                            sx={{ mt: "1rem", wordSpacing: "1px", lineHeight: "18px" }}
                            variant="subtitle1"
                            color="white">
                            In the meantime, feel free to browse the artwork gallery and start adding pieces to your
                            pieces favorites collection. collection.
                        </Typography>
                        <Box>
                            <Button
                                sx={{ mt: 1, right: "0px !important" }}
                                variant="contained"
                                size="large"
                                id="addSurvey"
                                color="primary"
                                onClick={handleBrowseGallery}>
                                Browse Gallery
                            </Button>
                        </Box>

                        <Button
                            sx={{ mt: 1, right: "0px !important", color: "white" }}
                            variant="text"
                            size="large"
                            id="addSurvey"
                            color="info"
                            onClick={handleGoToDashboard}>
                            Go to Dashboard
                        </Button>
                    </Box>
                </ModalContent>
            )}

            <AlertDialog
                title="Confirm"
                message="Are you sure, you want to submit the survey? After submitting you were not be able to update the survey records."
                open={openConfirmModal}
                onDisagree={handleDisagree}
                onAgree={handleAgree}></AlertDialog>

            <AlertDialog
                title="Confirm"
                message="Are you sure you want to delete this location?"
                open={openDeleteConfirmModal}
                onDisagree={handleDeleteDisagree}
                onAgree={handleDeleteAgree}></AlertDialog>
        </Container>
    );

    return getPageContent(body, status, error);
};

export { LocationSurvey };
